import {
  GetMaterializedProcessNameDocument,
  GetMaterializedProcessNameQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetMaterializedProcessName = (
  variables: GetMaterializedProcessNameQueryVariables
) => {
  const { data, loading } = useQuery(GetMaterializedProcessNameDocument, { variables })

  return {
    materializedProcess: data?.processes.materializedProcess,
    loading,
  }
}
